import React, { useCallback } from 'react';
import { Toast } from 'antd-mobile';
import i18n from '../../../i18n';
import { useReferralModel } from './model';
import { ReferralView } from './view';

export const ReferralWidget: React.FC = () => {
  const { state, shareUrl, refreshAll, changeChildrenPage, changeRewardsPage } = useReferralModel();

  const handleCopy = useCallback(async () => {
    if (!shareUrl) {
      return;
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
      Toast.show({ icon: 'success', content: i18n.t('referral:copySuccess') });
    } catch {
      Toast.show({ icon: 'fail', content: i18n.t('referral:copyFailed') });
    }
  }, [shareUrl]);

  return (
    <ReferralView
      state={state}
      shareUrl={shareUrl}
      onCopy={handleCopy}
      onRefresh={refreshAll}
      onChildrenPrev={() => changeChildrenPage(Math.max(state.childrenPagination.page - 1, 1))}
      onChildrenNext={() => changeChildrenPage(Math.min(state.childrenPagination.page + 1, Math.max(state.childrenPagination.totalPages, 1)))}
      onRewardsPrev={() => changeRewardsPage(Math.max(state.rewardsPagination.page - 1, 1))}
      onRewardsNext={() => changeRewardsPage(Math.min(state.rewardsPagination.page + 1, Math.max(state.rewardsPagination.totalPages, 1)))}
    />
  );
};

